import { render, staticRenderFns } from "./AdminPlace.vue?vue&type=template&id=1e35ad16"
import script from "./AdminPlace.vue?vue&type=script&lang=js"
export * from "./AdminPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports